export default "__VITE_ASSET__CwqhRkM___"